import "survey-core/defaultV2.min.css";
import React, { useEffect } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuth } from "react-oidc-context";
import { useLocation, useNavigate } from "react-router-dom";

function Login() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  
  console.log("Login component mounted. Auth state:", { 
    isLoading: auth.isLoading, 
    isAuthenticated: auth.isAuthenticated, 
    error: auth.error 
  });

  useEffect(() => {
    console.log("Login useEffect triggered. Auth state:", { 
      isLoading: auth.isLoading, 
      isAuthenticated: auth.isAuthenticated, 
      error: auth.error 
    });

    if (auth.isAuthenticated) {
      console.log("User is authenticated, navigating to:", from);
      navigate(from, { replace: true });
    } else if (!auth.isLoading) { // User is not authenticated and not loading
      if (auth.error) {
        // An error already exists. App.tsx's top-level error display will show it.
        // We avoid an immediate automatic redirect to prevent potential loops if signinRedirect consistently fails.
        console.error("Login page: Authentication error detected. User may need to manually initiate login or refresh if the issue was temporary.", auth.error);
      } else {
        // No existing error, attempt sign-in
        console.log("Attempting to redirect to signin...");
        // Pass the 'from' location in the state so Cognito can redirect back appropriately after login.
        auth.signinRedirect({ state: { returnUrl: from } })
          .catch(err => console.error("Error during signinRedirect in Login.tsx:", err));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate, from, auth]); // Added auth properties to dependency array for more explicit reactivity

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={2} sx={{ height: "100%" }}>
      <Typography>Redirecting to login...</Typography>
    </Stack>
  );
}

export default Login;
